import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export default function AirlineSelector({
  airlines = [],
  value = "",
  onSelect,
}) {
  const [open, setOpen] = useState(false);

  const selected = airlines.find(
    (a) => a.name === value
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          className="w-full justify-between"
        >
          {selected
            ? selected.name
            : "Search airline..."}

          <ChevronsUpDown className="ml-2 h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-[500px] p-0">
        <Command>
          <CommandInput placeholder="Search airline..." />

          <CommandList>
            <CommandEmpty>
              Airline not found
            </CommandEmpty>

            <CommandGroup>
              {airlines.map((airline) => (
                <CommandItem
                  key={airline.id}
                  value={airline.name}
                  onSelect={() => {
                    onSelect(airline);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={`mr-2 h-4 w-4 ${
                      value === airline.name
                        ? "opacity-100"
                        : "opacity-0"
                    }`}
                  />

                  <div>
                    <div className="font-medium">
                      {airline.name}
                    </div>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
